/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_No_Commits_TitleInputs */



/**
* | output |
* | --- |
* | "No Commits" |
*
* @param {Team_Share_No_Commits_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_no_commits_title = /** @type {((inputs?: Team_Share_No_Commits_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_No_Commits_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun commit")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Verpflichtungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun impegno")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Без обязательств")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin compromisos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("没有提交")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コミットなし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई प्रतिबद्धता नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sem commits")
	return /** @type {LocalizedString} */ ("No Commits")
});